// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"ac146bc8","119":"6a145aee","131":"e211070a","159":"cdcaa6d8","395":"980506d8","428":"40fbb534","496":"c63c45f3","682":"10ec8c9f","757":"bf520fe6","966":"658ce802"}[chunkId] + ".chunk.js";
};